<template>
    <b-container fluid class="p-0 bg-primary web-header shadow-sm">
        <b-container>
            <b-navbar toggleable="lg" type="dark" variant="primary" class="w-100">

                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                <b-collapse id="nav-collapse" is-nav class="justify-content-center w-100" >
                    <b-navbar-nav fill class="w-100">
                        <b-nav-item   v-for="(nav,index) in navsDatas" :active="activeNav.key == nav.key" :key="index" @click="onClickNavItem(nav)">{{nav.text}}</b-nav-item>
                        <!-- <b-nav-item href="#" >首页</b-nav-item>
                        <b-nav-item href="#" >首页</b-nav-item>
                        <b-nav-item-dropdown text="首页">
                            <b-dropdown-item href="#">EN</b-dropdown-item>
                            <b-dropdown-item href="#">ES</b-dropdown-item>
                            <b-dropdown-item href="#">RU</b-dropdown-item>
                            <b-dropdown-item href="#">FA</b-dropdown-item>
                        </b-nav-item-dropdown>
                        <b-nav-item href="#" >首页</b-nav-item>
                        <b-nav-item href="#" >首页</b-nav-item>
                        <b-nav-item href="#" >首页</b-nav-item>
                        <b-nav-item href="#" >首页</b-nav-item> -->
                    </b-navbar-nav>
                </b-collapse>
                <!-- <b-navbar-nav fill v-if="!navsConfig.navbarShowChildren" class="w-100">
                    <b-nav-item href="#" active>首页</b-nav-item>
                    <b-nav-item href="#" >首页</b-nav-item>
                    <b-nav-item href="#" >首页</b-nav-item>
                    <b-nav-item href="#" >首页</b-nav-item>
                    <b-nav-item href="#" >首页</b-nav-item>
                    <b-nav-item href="#" >首页</b-nav-item>
                    <b-nav-item href="#" >首页</b-nav-item>
                </b-navbar-nav> -->
            </b-navbar>
        </b-container>
    </b-container>
    
    
  </template>
  
  <script>
  
import store from '@/store'
  export default {
    name: 'navbar',
    props: {
        navs: {
            type:Array,
            default(){
                return [
                    // {
                    //     text:"首页",
                    //     href:'/'
                    // },{
                    //     text:"关于学会",
                    //     href:'/'
                    // },{
                    //     text:"学会资讯",
                    //     href:''
                    // },{
                    //     text:"继续教育",
                    //     href:''
                    // },{
                    //     text:"健康中国行动",
                    //     href:''
                    // },{
                    //     text:"全民营养周",
                    //     href:''
                    // },{
                    //     text:"科普宣传",
                    //     href:''
                    // },{
                    //     text:"教育培训",
                    //     href:''
                    // },{
                    //     text:"会员注册",
                    //     href:''
                    // },{
                    //     text:"理事单位",
                    //     href:''
                    // },{
                    //     text:"资料下载",
                    //     href:''
                    // }
                ]
            }
        }
        
    },

    data() {
      return {
        active:null
        
      }
    },
    computed:{
        navsConfig(){
            let config  = this.webConfig.navs || {
                navbarShowChildren:false
            }
            return config
        },
        navsDatas(){
            let datas = []
            datas = store.getters.getNavs
            if(!this.navsConfig.navbarShowChildren){
                datas = datas.filter(item => !item.parent_no)
            }
            return datas
        },
        activeNav(){
            let active = null
            active = store.getters.getActiveNav
            return active
        }
    },
    watch: {
        '$route': {
            handler(to) {
                this.syncActiveNavByRoute(to)
            }
        },
        navsDatas: {
            handler(val) {
                if (val && val.length > 0) {
                    this.syncActiveNavByRoute(this.$route)
                }
            }
        }
    },
    mounted() {
        this.syncActiveNavByRoute(this.$route)
    },
    methods:{
        syncActiveNavByRoute(route) {
            let navs = store.getters.getNavs
            if (!navs || navs.length === 0) return

            let matched = null
            
            if (route.params && route.params.no) {
                let rootNavs = navs.filter(item => !item.parent_no)
                matched = rootNavs.find(nav => nav.key === route.params.no)
            }
            
            if (!matched) {
                for (let nav of navs) {
                    if (nav.href === '/' && (route.path === '/' || route.name === 'index')) {
                        matched = nav
                        break
                    }
                    if (nav.href && nav.href !== '/' && nav.href !== '#' && route.path.startsWith('/' + nav.href)) {
                        matched = nav
                        break
                    }
                }
            }
            
            if (matched) {
                store.commit('setActiveNav', matched)
            }
        },
        onClickNavItem(e,parent){
            let self = this
            // console.log(e.href)
            let path = e.href
            let nav = e
             
            store.commit('setActiveNav',nav)   
            let navs = store.getters.getNavs
            navs = this.getTree(navs,'key','parent_no',e.key)
            if(navs.length == 1){
                navs = navs[0]
            }
            // console.log(navs)
            if(path !== '#' && path){
                let active = navs.children.length > 0 ? navs.children[0] : e

                this.toHomePage(active, null, { source: 'homepage' })

                // path = path == '/' ? path : `/${path}/${nav.key}/${active.key}/list/${active.key}`
                // path = path == 'index' ? path : `${path}`
                
                // console.log(path)
                // self.$router.push(path,(sce => {
                //     console.log('跳转异常：',sce)
                // }),(err => {
                //     console.log('跳转异常：',err)
                // }))
            }else{
                let nonePath = `/none?timer=${new Date().getTime()}`
                self.$router.push(nonePath,(sce => {
                     console.log('跳转异常：',sce)
                }),(err => {
                    console.log('跳转异常：',err)
                }))
            }
            
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style >

  </style>
  